// Animation variants, re-exported for consumers.
//
// The variant objects in ./variants are fully type-checked at authoring time
// against the app-local `AnimationVariants` type. Framer-motion's own
// `Variants` type is structurally unusable under the preact/compat alias (a
// leaked `[key: string]: string | number` index signature collides with the
// object-typed `transition` field — see the note in ./variants), so a concrete
// variant cannot be assigned to a `variants={...}` prop directly. `toFramer`
// is the single library-boundary adapter that re-casts our typed variants to
// framer's `Variants`. The input stays type-checked; only the framer shape is
// asserted.

import type { Variants } from 'framer-motion';
import type { AnimationVariants } from './variants';
import * as v from './variants';

const toFramer = (variant: AnimationVariants): Variants => variant as unknown as Variants;

export const cardFlip = toFramer(v.cardFlip);
export const cardInner = toFramer(v.cardInner);
export const cardBackContent = toFramer(v.cardBackContent);
export const cardSwipe = toFramer(v.cardSwipe);
export const quizOption = toFramer(v.quizOption);
export const particleOption = toFramer(v.particleOption);
export const modalOverlay = toFramer(v.modalOverlay);
export const modalContent = toFramer(v.modalContent);
export const toast = toFramer(v.toast);
export const progressFill = toFramer(v.progressFill);
export const levelOption = toFramer(v.levelOption);
export const timerPulse = toFramer(v.timerPulse);
export const blankPulse = toFramer(v.blankPulse);
export const srsIndicator = toFramer(v.srsIndicator);
export const audioButton = toFramer(v.audioButton);
export const tabContent = toFramer(v.tabContent);
export const counterTick = toFramer(v.counterTick);
export const flashcardContainer = toFramer(v.flashcardContainer);
export const dropdown = toFramer(v.dropdown);
export const staggerContainer = toFramer(v.staggerContainer);
export const staggerItem = toFramer(v.staggerItem);
export const feedbackIcon = toFramer(v.feedbackIcon);

// Utility hook for reduced motion
export { useReducedMotion } from 'framer-motion';
